export enum HistoryType {
    bets = 'bets',
    casinoPlays = 'casinoPlays',
    transactions = 'transactions',
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/ui/user/history/enums.ts